<template>
    <div class="challenge-counter">
        Nästa utmaning
        <span
            >{{ this.lessThenTen(days) }} : {{ this.lessThenTen(hours) }} : {{ this.lessThenTen(minutes) }} :
            {{ this.lessThenTen(seconds) }}</span
        >
    </div>
</template>

<script>
export default {
    data() {
        return {
            // now: Math.trunc((new Date(new Date().getHours() -(new Date().getTimezoneOffset() / 60)).getTime() / 1000)),
            now: this.getTime()
        };
    },

    props: {
        date: {
            type: Number,
            coerce: (str) => Math.trunc(Date.parse(str) / 1000)
        }
    },

    computed: {
        // now() {
        //     let d = new Date();
        //     return Math.trunc(d.getTime() / 1000);
        // },

        converted() {
            let offset = -(new Date().getTimezoneOffset() / 60);
            return new Date(this._props.date.raw + ' 00:00:00 GMT+0' + offset + '00');
        },

        seconds() {
            return (Math.trunc(Date.parse(this.converted) / 1000) - this.now) % 60;
        },

        minutes() {
            return Math.trunc((Math.trunc(Date.parse(this.converted) / 1000) - this.now) / 60) % 60;
        },

        hours() {
            return Math.trunc((Math.trunc(Date.parse(this.converted) / 1000) - this.now) / 60 / 60) % 24;
        },

        days() {
            return Math.trunc((Math.trunc(Date.parse(this.converted) / 1000) - this.now) / 60 / 60 / 24);
        }
    },

    mounted() {
        // console.log(this.converted)

        window.setInterval(() => {
            // let offset = -(new Date().getTimezoneOffset() / 60);
            // let now =  new Date(this._props.date.raw + ' 00:00:00 GMT+0' + offset +'00');

            // this.now = Math.trunc((now.getTime() / 1000));

            // let d = new Date();
            // d.setHours(d.getHours() + offset);
            this.now = this.getTime();
        }, 1000);
    },

    methods: {
        getTime() {
            return Math.trunc(new Date().getTime() / 1000);
        },

        lessThenTen(number) {
            if (number < 10) {
                return '0' + number;
            } else {
                return number;
            }
        }
    }
};
</script>
